import { Component, OnInit } from '@angular/core';
import { Crisp } from 'crisp-sdk-web';
import { MenuContextService } from '../../layout/services/menu-context.service';
import { MenuExpandContextService } from '../../layout/services/menu-expand-context.service';
import { Router } from '@angular/router';
import { TitleService } from '../../../services/title/title.service';
import { UserAuthService } from '../../../services/user/user-auth.service';
import { FormControl } from '../../../helpers/crud/edit/form-control/form-control.model';
import { debounceTime } from 'rxjs';
import { DateTime } from 'luxon';
import { ScreenService } from '../services/screen.service';
import { MatDialog } from '@angular/material/dialog';
import { PlayerComponent } from '../../spots/player/player.component';
declare const launchUpload: any;
declare const launchEditor: any;
declare const launchGraphs: any;
declare const fbq: any;

@Component({
  selector: 'app-spot',
  templateUrl: './spot.component.html',
  styleUrl: './spot.component.scss'
})

export class SpotComponent implements OnInit {

  public spotFormControl: FormControl;
  public templateFormControl : FormControl;
  public nbrFaceSelected: number = null;
  public faceSelectedId: any = null;
  public campaignStartDate: any =null;
  public campaignEndDate: any = null;
  public faceSelectedResolution: any = [];
  public resolutionLoader = true;
  public window = <Window>window;
  public showTemplate: boolean = false;

  //MARK: Constructor
  constructor(
      private menuContext$: MenuContextService,
      private menuExpandContext$: MenuExpandContextService,
      private router: Router,
      public title$: TitleService,
      private userAuth$: UserAuthService,
      public screen$: ScreenService,
      public dialog: MatDialog,
  ) {
      setTimeout(() => {
          this.title$.next('Spot');
      }, 0);
  }

  ngOnInit(): void {
      if (!Crisp.isCrispInjected()) {
          Crisp.configure('7d4a0471-984f-4f44-a5cd-e0ef1ef779b4');
      } else {
          Crisp.chat.show();
      }
      // Lancement animation lottie
      setTimeout(() => {
          // launchEditor();
          
      }, 10);
      this.nbrFaceSelected = localStorage.getItem('selectedFace').split(',').length;
      this.faceSelectedId = localStorage.getItem('selectedFace');

      this.spotFormControl=new FormControl("spotFormControl");
      this.campaignEndDate = localStorage.getItem('campaignEndDate');
      this.campaignEndDate = DateTime.fromJSDate(
        new Date(this.campaignEndDate)
      ).toISODate();
      this.campaignStartDate = localStorage.getItem('campaignStartDate');
      this.campaignStartDate = DateTime.fromJSDate(
        new Date(this.campaignStartDate)
      ).toISODate();
      if( localStorage.getItem('spotOrdered') != null){
        this.spotFormControl.setValue(localStorage.getItem('spotOrdered'));
      }
      else{
        this.spotFormControl.setValue(0);
      }
      this.templateFormControl = new FormControl("templateFormControl");
      if( localStorage.getItem('templateOrdered') != null){
        this.templateFormControl.setValue(localStorage.getItem('templateOrdered'));
      }
      else{
        this.templateFormControl.setValue(0);
      }

      
      this.templateFormControl.valueChanges
      .pipe(debounceTime(700))
      .subscribe((hi) => {
          localStorage.set('templateOrdered',  this.templateFormControl.value);
      });

      // this.screen$.getSize(this.faceSelectedId.split(',')).subscribe((res : any)=>{
      //   this.faceSelectedResolution = res;
      //   this.resolutionLoader = false;
      // });

      const videoMappings = [
        {
          thumbId: 'restaurantThumb',
          wrapperId: 'restaurant-wrapper',
          videoUrl: 'https://wancomresource.s3.eu-west-3.amazonaws.com/template+restaurant.mp4'
        },
        {
          thumbId: 'agenceThumb',
          wrapperId: 'agence-wrapper',
          videoUrl: 'https://wancomresource.s3.eu-west-3.amazonaws.com/Agence+de+voyage+blanc.mp4'
        },
        {
          thumbId: 'locationVoitureThumb',
          wrapperId: 'location-wrapper',
          videoUrl: 'https://wancomresource.s3.eu-west-3.amazonaws.com/Location+de+voiture.mp4'
        },
        {
          thumbId: 'directionnelThumb',
          wrapperId: 'directionnel-wrapper',
          videoUrl: 'https://wancomresource.s3.eu-west-3.amazonaws.com/template+directionnel.mp4'
        }
      ];

      videoMappings.forEach(({ thumbId, wrapperId, videoUrl }) => {
        document.getElementById(thumbId).addEventListener('click', function () {
          document.getElementById(wrapperId).innerHTML = `
        <video controls loop muted autoplay style="width: 100%;" (click)="openFullscreen('${videoUrl}')">
          <source src="${videoUrl}" type="video/mp4">
          
        </video>`;
        });
      });
  }
  goBack(){
    localStorage.setItem('templateOrdered', this.templateFormControl.value);
    localStorage.setItem('spotOrdered', this.spotFormControl.value);
    this.router.navigateByUrl('/store');
  }
  goToCart(){
    if (this.window && this.window.dataLayer != null) {
        this.window.dataLayer = window.dataLayer || [];
        this.window.dataLayer.push({
            event: 'spot_valide',
        });
        fbq('track', 'spot_valide', {});
    }
    else{
        this.window.dataLayer= window.dataLayer || [];
        this.window.dataLayer.push({
            event: 'spot_valide',
        });
        fbq('track', 'spot_valide', {});

    }
    localStorage.setItem('templateOrdered', this.templateFormControl.value);
    localStorage.setItem('spotOrdered', this.spotFormControl.value);
    this.router.navigateByUrl('/store/cart');
  }

  addValue(){
    this.spotFormControl.setValue(Number(this.spotFormControl.value) +1);
  }

  removeValue(){
    if(this.spotFormControl.value > 0){
      this.spotFormControl.setValue(Number(this.spotFormControl.value) -1);
    }
  }

  openFullscreen(url){
    const dialogRef = this.dialog.open(PlayerComponent, {
      width: '80%',
    });
    dialogRef.componentInstance.videoUrl  = url;
    dialogRef.componentInstance.loadVideo();

  }

}
